require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-we-re-launching-a-women-only-ruby-on-rails-class-this-summer.json") })
        }
      }, "path---blog-we-re-launching-a-women-only-ruby-on-rails-class-this-summer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-we-re-launching-a-women-only-ruby-on-rails-class-this-summer!./.cache/json/blog-we-re-launching-a-women-only-ruby-on-rails-class-this-summer.json
// module id = 1103
// module chunks = 231608221292675